import React from 'react';
import { View, ViewProps } from 'react-native';
import { PlatformPadding } from 'src/components/PlatformPadding';
import useStyles from './Separator.styles';

type SeparatorProps = ViewProps & {
  size?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'xxxl';
  padding?: boolean;
  /**
   * Line mode draws only the line without paddings.
   */
  line?: boolean;
  direction?: 'top' | 'bottom';
};

export const Separator: React.FC<SeparatorProps> = ({
  padding = false,
  line = false,
  size = 'm',
  direction,
  style,
  ...props
}) => {
  const s = useStyles();

  return (
    <PlatformPadding horizontal={padding}>
      <View
        style={[line ? s.line : s[size], !line && direction && s[direction], style]}
        {...props}
      />
    </PlatformPadding>
  );
};
